import { useContext, useEffect, useState } from "react";
import { abpnClient } from "../../../../Services/AbpnClient";
import { AuthContext } from "../../../Auth/AuthProvider";
import AbpnSpinner from "../../../Shared/Components/AbpnSpinner";
import { AvailableExamination } from "../Models/AvailableExamination";
import AvailableExaminationGroup from "./AvailableExaminationGroup";
import Physician from "../../../Physician/Models/Physician";

export default function AvailableApplicationGrid() {
    const [availableExams, setAvailableExams] = useState<AvailableExamination[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [physician, setPhysician] = useState<Physician>(null);
    const authContext = useContext(AuthContext);

    useEffect(() => {
        const loadData = async () => {

           await abpnClient.get<Array<AvailableExamination>>("/api/application/available", authContext)
            .then(exams => {
                setAvailableExams(exams);
            });

            await abpnClient.get<Physician>("/api/physician", authContext)
            .then(physician => {
                setPhysician(physician);
            });

            setLoading(false);
        }

        if(loading) loadData();
        
    }, []);

    if (loading) return <AbpnSpinner></AbpnSpinner>;
    return (
        <div className="ml-3 mr-3" >
            <h3 className="mb-3 text-pp-secondary font-weight-bold">Apply for Exam</h3>
            <AvailableExaminationGroup
                key="Article Assessment Continuing Certification Applications"
                title="Article Assessment Continuing Certification Applications"
                examinations={availableExams.filter(_ => _.isMoc && _.isArticleBased)}
                currentCCEnrollment={null} />
            <AvailableExaminationGroup
                key="Continuing Certification Applications"
                title="Continuing Certification Applications"
                examinations={availableExams.filter(_ => _.isMoc && !_.isArticleBased)} 
                currentCCEnrollment={physician.currentCCEnrollment} />
            <AvailableExaminationGroup
                key="Specialty Certification Applications"
                title="Specialty Certification Applications"
                examinations={availableExams.filter(_ => !_.isMoc && _.isPrimary)} 
                currentCCEnrollment={null} />
            <AvailableExaminationGroup
                key="Subspecialty Certification Applications"
                title="Subspecialty Certification Applications"
                examinations={availableExams.filter(_ => !_.isMoc && !_.isPrimary)} 
                currentCCEnrollment={null} />
        </div>
    );
}